enum CarrierNames {
  ASENDIA = 'Asendia',
  BRING = 'Bring',
  CITYMAIL = 'CityMail',
  LETTER_CARRIER = 'Mailworld',
  DEUTSCHE_POST = 'Deutsche Post',
  DHL_FREIGHT = 'DHL Freight',
  DHL_EXPRESS = 'DHL Express',
  EARLYBIRD = 'EarlyBird',
  POSTNORD = 'PostNord',
  POSTI = 'Posti',
  UPS = 'UPS',
}

export default CarrierNames
